/* Strokes gained calculator — DOM wiring for
   sections/strokes-gained-calculator.liquid. Single shot by design: the page
   scores one shot, keeps a running tally as the visitor chains shots with
   "Score the next shot", and hands off to the app for the whole round.
   All math lives in strokes-gained-engine.js (window.WGStrokesGained).
   Events go through window.wgTrack (snippets/wg-tracking.liquid):
     wg_sg_shot {label: category, value: sg}   a completed shot, once per shot
     wg_sg_next {value: shots so far}          "Score the next shot"
     wg_sg_app_click {label: lock}             the locked-preview button (data-track) */
(function () {
  'use strict';

  var UNITS_KEY = 'wg_sg_units';
  var EXAMPLE = { startLie: 'fairway', startDist: 160, endLie: 'green', endDist: 20, units: 'yd', par: 4 };
  var LIE_PHRASES = {
    tee: 'from the tee', fairway: 'in the fairway', rough: 'in the rough',
    sand: 'in the sand', recovery: 'in recovery', green: 'on the green'
  };
  var SHOT_KIND = {
    off_tee: 'Tee shot', approach: 'Approach shot', around_green: 'Around the green', putting: 'Putt'
  };
  var SHOTS_PER_ROUND = 90;

  function storeGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function storeSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* storage blocked: fine */ }
  }
  function track(action, params) {
    if (typeof window.wgTrack === 'function') window.wgTrack(action, params || {});
  }
  function num(v) {
    if (v === '' || v === null || v === undefined) return NaN;
    var n = parseFloat(String(v).replace(',', '.'));
    return isFinite(n) && n > 0 ? n : NaN;
  }
  function tone(x) {
    var r = Math.round(x * 100) / 100;
    return r > 0 ? 'gain' : r < 0 ? 'loss' : 'even';
  }
  function unitWord(lie, units) {
    if (lie === 'green') return 'ft';
    return units === 'm' ? 'm' : 'yds';
  }
  function posText(lie, dist, units) {
    if (lie === 'holed') return 'in the hole';
    return (Math.round(Number(dist) * 10) / 10) + ' ' + unitWord(lie, units) + ' ' + LIE_PHRASES[lie];
  }
  function plain(sgText) { return sgText.replace('−', '-'); }

  function init(root) {
    var SG = window.WGStrokesGained;
    if (!SG || root.dataset.sgReady) return;
    root.dataset.sgReady = '1';
    root.classList.add('sg--js');

    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var form = q('[data-sg-form]');
    var el = {
      units: qa('[data-sg-units]'),
      startLies: qa('[data-sg-lie="start"]'),
      endLies: qa('[data-sg-lie="end"]'),
      startDist: q('[data-sg-dist="start"]'),
      endDist: q('[data-sg-dist="end"]'),
      endDistWrap: q('[data-sg-end-dist-wrap]'),
      startSuffix: q('[data-sg-suffix="start"]'),
      endSuffix: q('[data-sg-suffix="end"]'),
      startHint: q('[data-sg-hint="start"]'),
      endHint: q('[data-sg-hint="end"]'),
      penalty: q('[data-sg-penalty]'),
      par3: q('[data-sg-par3]'),
      par3Wrap: q('[data-sg-par3-wrap]'),
      inline: q('[data-sg-inline]'),
      next: q('[data-sg-next]'),
      heading: q('[data-sg-card-heading]'),
      ring: q('[data-sg-ring]'),
      value: q('[data-sg-value]'),
      category: q('[data-sg-category]'),
      read: q('[data-sg-read]'),
      math: q('[data-sg-math]'),
      tally: q('[data-sg-tally]')
    };
    var headings = { example: root.dataset.hExample, result: root.dataset.hResult };
    var state = {
      units: storeGet(UNITS_KEY) === 'm' ? 'm' : 'yd',
      scored: [],          // sg of shots the visitor moved past with "Score the next shot"
      lastTracked: ''
    };

    function checkedValue(list) {
      for (var i = 0; i < list.length; i++) if (list[i].checked) return list[i].value;
      return null;
    }
    function setChecked(list, value) {
      list.forEach(function (input) { input.checked = input.value === String(value); });
    }

    function currentShot() {
      var endLie = checkedValue(el.endLies);
      return {
        startLie: checkedValue(el.startLies),
        startDist: num(el.startDist.value.trim()),
        endLie: endLie,
        endDist: endLie === 'holed' ? 0 : num(el.endDist.value.trim()),
        penalty: el.penalty.checked,
        units: state.units,
        par: el.par3.checked ? 3 : 4
      };
    }
    function shotKey(s) {
      return [s.startLie, s.startDist, s.endLie, s.endDist, s.penalty, s.units, s.par].join('|');
    }

    function rangeHint(lie, raw) {
      var d = num(raw);
      if (isNaN(d) || lie === 'holed') return '';
      var L = SG.LIMITS;
      if (lie === 'green') {
        return d > L.puttMax ? 'The putting baseline covers 1 to ' + L.puttMax + ' ft; using ' + L.puttMax + '.' : '';
      }
      if (SG.toEngineDistance(lie, d, state.units) > L.longMax) {
        var shown = state.units === 'm' ? Math.round(L.longMax / SG.METRES_TO_YARDS) + ' m' : L.longMax + ' yds';
        return 'The baseline covers up to ' + shown + '; using ' + shown + '.';
      }
      return '';
    }

    function syncFields(shot) {
      var m = state.units === 'm';
      el.startSuffix.textContent = unitWord(shot.startLie, state.units) + ' to the hole';
      el.endSuffix.textContent = unitWord(shot.endLie, state.units) + ' to the hole';
      el.startDist.placeholder = shot.startLie === 'green' ? '20' : shot.startLie === 'tee' ? (m ? '365' : '400') : (m ? '145' : '160');
      el.endDist.placeholder = shot.endLie === 'green' ? '20' : (m ? '130' : '140');
      el.endDistWrap.hidden = shot.endLie === 'holed';
      el.par3Wrap.hidden = shot.startLie !== 'tee';

      el.startHint.textContent = rangeHint(shot.startLie, el.startDist.value);
      var endHint = rangeHint(shot.endLie, el.endDist.value);
      if (!endHint && !shot.penalty && shot.endLie !== 'holed') {
        var comparable = (shot.startLie === 'green') === (shot.endLie === 'green');
        if (comparable && shot.endDist > shot.startDist) {
          endHint = 'It finished further away than it started. That is allowed, just check the numbers.';
        }
      }
      el.endHint.textContent = endHint;
    }

    function eqRow(label, number, op) {
      var row = document.createElement('div');
      row.className = 'sg__eq-row';
      var l = document.createElement('span');
      l.className = 'sg__eq-label';
      l.textContent = label;
      var n = document.createElement('span');
      n.className = 'sg__eq-num';
      if (op) {
        var o = document.createElement('span');
        o.className = 'sg__eq-op';
        o.textContent = '\u2212';
        n.appendChild(o);
      }
      n.appendChild(document.createTextNode(number));
      row.appendChild(l);
      row.appendChild(n);
      return row;
    }

    // The working as a stacked sum: start, minus finish, minus strokes, a bar, the answer.
    function renderEquation(r, shot) {
      var eq = el.math;
      eq.textContent = '';
      var start = posText(shot.startLie, shot.startDist, shot.units);
      eq.appendChild(eqRow('Expected from ' + start, r.startExpected.toFixed(2), false));
      eq.appendChild(shot.endLie === 'holed'
        ? eqRow('Holed, nothing left', '0.00', true)
        : eqRow('Expected from ' + posText(shot.endLie, shot.endDist, shot.units), r.endExpected.toFixed(2), true));
      eq.appendChild(eqRow(r.strokes === 2 ? 'Strokes used, with the penalty' : 'Stroke used', r.strokes.toFixed(2), true));
      var total = document.createElement('div');
      total.className = 'sg__eq-row sg__eq-row--total sg__eq-row--' + tone(r.sg);
      var l = document.createElement('span');
      l.className = 'sg__eq-label';
      l.textContent = 'Strokes gained';
      var n = document.createElement('strong');
      n.className = 'sg__eq-num';
      n.textContent = SG.fmt(r.sg);
      total.appendChild(l);
      total.appendChild(n);
      eq.appendChild(total);
    }

    function renderResult(r, shot) {
      var t = tone(r.sg);
      el.ring.classList.toggle('sg__ring--gain', t === 'gain');
      el.ring.classList.toggle('sg__ring--loss', t === 'loss');
      el.value.textContent = SG.fmt(r.sg);
      el.category.textContent = SHOT_KIND[r.category];
      el.read.textContent = SG.readLine(r.sg);
      renderEquation(r, shot);
    }

    function renderTally(r) {
      var shots = state.scored.length + (r ? 1 : 0);
      if (shots < 2) { el.tally.hidden = true; return; }
      var total = state.scored.reduce(function (a, b) { return a + b; }, 0) + (r ? r.sg : 0);
      el.tally.hidden = false;
      el.tally.textContent = shots + ' shots scored: ' + SG.fmt(total) + ' total. A round is about ' +
        SHOTS_PER_ROUND + ' of them. The app scores every one for you.';
    }

    function render() {
      var shot = currentShot();
      syncFields(shot);
      var r = SG.strokesGained(shot);
      if (r) {
        el.heading.textContent = headings.result;
        renderResult(r, shot);
        el.inline.textContent = SG.fmt(r.sg) + ' strokes gained · ' + SHOT_KIND[r.category];
        el.inline.className = 'sg__inline sg__inline--' + tone(r.sg);
      } else {
        el.heading.textContent = headings.example;
        renderResult(SG.strokesGained(EXAMPLE), EXAMPLE);
        el.inline.textContent = '';
      }
      el.next.disabled = !r;
      renderTally(r);
      return r;
    }

    function trackShot() {
      var shot = currentShot();
      var r = SG.strokesGained(shot);
      if (!r) return;
      var key = shotKey(shot);
      if (key === state.lastTracked) return;
      state.lastTracked = key;
      track('sg_shot', { label: r.category, value: plain(SG.fmt(r.sg)), element: root });
    }

    // Move on: bank this shot in the tally and start the next one where it finished.
    function nextShot() {
      var shot = currentShot();
      var r = SG.strokesGained(shot);
      if (!r) return;
      trackShot();
      state.scored.push(r.sg);
      track('sg_next', { value: String(state.scored.length), element: root });
      if (shot.endLie === 'holed') {
        setChecked(el.startLies, 'tee');
        el.startDist.value = '';
        setChecked(el.endLies, 'fairway');
      } else {
        setChecked(el.startLies, shot.endLie);
        el.startDist.value = el.endDist.value.trim();
        setChecked(el.endLies, shot.endLie === 'green' ? 'holed' : 'green');
      }
      el.endDist.value = '';
      el.penalty.checked = false;
      el.par3.checked = false;
      state.lastTracked = '';
      render();
      (shot.endLie === 'holed' ? el.startDist : el.endDist).focus({ preventScroll: true });
    }

    el.units.forEach(function (u) {
      u.addEventListener('change', function () {
        state.units = u.value === 'm' ? 'm' : 'yd';
        storeSet(UNITS_KEY, state.units);
        render();
      });
    });
    form.addEventListener('input', function (e) {
      if (!e.target.matches('[data-sg-units]')) render();
    });
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-sg-units]')) return;
      if (e.target.matches('[data-sg-lie="end"]') && e.target.value !== 'holed' && !el.endDist.value) {
        el.endDist.focus({ preventScroll: true });
      }
      render();
      trackShot();
    });
    // "Score the next shot" is the form's submit button, so Enter in a
    // distance box scores the next shot too (and does nothing while disabled).
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      nextShot();
    });

    function renderQr() {
      var box = root.querySelector('[data-sg-qr]');
      if (!box || !box.dataset.qrUrl || typeof window.qrcode !== 'function') return;
      try {
        var qr = window.qrcode(0, 'M');
        qr.addData(box.dataset.qrUrl);
        qr.make();
        box.innerHTML = qr.createSvgTag({ cellSize: 4, margin: 0, scalable: true });
      } catch (e) { /* no QR is fine; the badges remain */ }
    }

    setChecked(el.units, state.units);
    render();
    if (document.readyState === 'complete') renderQr();
    else window.addEventListener('load', renderQr);
  }

  function boot() {
    document.querySelectorAll('[data-sg]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-sg]');
    if (root) init(root);
  });
})();
